module.exports = __webpack_public_path__ + "static/media/screen-search-results.47d432d7.png";